import { useState } from "react";
import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import Lightbox from "@/components/feature/Lightbox";
import { galleryList } from "@/mocks/gallery";

export default function HomeGallerySection() {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);
  const items = galleryList.slice(0, 5);

  return (
    <section className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20 lg:px-12">
      <SectionHeading
        kicker="Gallery"
        title="写真精选"
        description="棚拍、活动现场与宣传照的年度精选。点击任意图片可以查看大图，并左右翻页浏览。"
        action={
          <Link
            to="/gallery"
            className="inline-flex w-fit cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-4 py-2 text-xs text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            进入图集
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        }
      />

      <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
        <button
          type="button"
          onClick={() => setLightboxIndex(0)}
          className="group relative col-span-2 row-span-2 h-[280px] cursor-pointer overflow-hidden rounded-lg bg-background-200 md:h-full md:min-h-[420px]"
        >
          <img
            src={items[0].image}
            alt={`${items[0].title} - 张柏芝写真大图`}
            title={`${items[0].title} - 张柏芝写真图集`}
            className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
          <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] text-foreground-800">
            {items[0].category}
          </span>
          <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 to-transparent p-4 pt-12 text-left">
            <span className="block font-heading text-sm text-background-50">{items[0].title}</span>
            <span className="mt-1 block text-[11px] text-background-300">点击查看大图</span>
          </span>
          <span className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-foreground-950/45 text-background-50 opacity-0 transition-opacity group-hover:opacity-100">
            <i className="ri-zoom-in-line" aria-hidden="true"></i>
          </span>
        </button>

        {items.slice(1).map((item, i) => (
          <button
            key={item.id}
            type="button"
            onClick={() => setLightboxIndex(i + 1)}
            className="group relative h-[135px] cursor-pointer overflow-hidden rounded-lg bg-background-200 md:h-[200px]"
          >
            <img
              src={item.image}
              alt={`${item.title} - 张柏芝${item.category}缩略图`}
              title={`${item.title} - 张柏芝写真图集`}
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/80 to-transparent px-3 pb-2.5 pt-8 text-left text-[11px] text-background-100">
              {item.title}
            </span>
          </button>
        ))}
      </div>

      {lightboxIndex !== null && (
        <Lightbox
          items={items}
          index={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
          onPrev={() => setLightboxIndex((current) => ((current ?? 0) - 1 + items.length) % items.length)}
          onNext={() => setLightboxIndex((current) => ((current ?? 0) + 1) % items.length)}
          onSelect={(target) => setLightboxIndex(target)}
        />
      )}
    </section>
  );
}